import {
  POD_SECURITY_MODE_FIELDS,
  PodSecurityStandardsFormValues,
} from '@/react/portainer/policies/components/kubernetes/pod-security-standards/types';

import { FormSection } from '@@/form-components/FormSection';
import { Badge } from '@@/Badge';

import { PolicyEmptyState } from './PolicyEmptyState';
import { PolicyTableWrapper } from './PolicyTableWrapper';

interface Props {
  formData: PodSecurityStandardsFormValues;
}

/**
 * Read-only table display of a Pod Security Standards policy: the profile set for each mode per namespace.
 */
export function PodSecurityStandardsPolicyReadOnly({ formData }: Props) {
  const namespaces = formData.namespaces || [];

  if (namespaces.length === 0) {
    return (
      <PolicyEmptyState
        title="Namespaces"
        message="No namespaces configured for this policy."
      />
    );
  }

  return (
    <FormSection title="Namespaces">
      <PolicyTableWrapper
        caption="Pod Security Standards profile per mode and namespace"
        data-cy="pss-policy-readonly-table"
      >
        <thead className="bg-gray-3 th-highcontrast:bg-gray-9 th-dark:bg-gray-9">
          <tr>
            <th className="px-4 py-3 text-left text-sm font-medium">
              Namespace
            </th>
            {POD_SECURITY_MODE_FIELDS.map(({ mode, label }) => (
              <th
                key={mode}
                className="px-4 py-3 text-left text-sm font-medium"
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-5 th-highcontrast:divide-gray-7 th-dark:divide-gray-7">
          {namespaces.map((entry) => (
            <tr
              key={entry.namespace}
              className="bg-gray-2 th-highcontrast:bg-black th-dark:bg-gray-iron-10"
            >
              <td className="px-4 py-3 text-sm font-medium">
                {entry.namespace}
              </td>
              {POD_SECURITY_MODE_FIELDS.map(({ mode }) => (
                <td key={mode} className="px-4 py-3">
                  {entry[mode] ? (
                    <Badge type="info">{entry[mode]}</Badge>
                  ) : (
                    <span className="text-muted text-sm">—</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </PolicyTableWrapper>
    </FormSection>
  );
}
